__turbopack_context__.v({
  "venti-widget": "_3xJHEq_venti-widget",
});
